<div class="high-low-day-component" (window:beforeunload)="ngOnDestroy()">
  <div class="component-header">
    <span>{{ title }}</span>
    <div class="icons gridster-ignore-drag">
      <!-- <mat-icon *ngIf="!newWindow" svgIcon="chain"></mat-icon>  -->
      <mat-icon *ngIf="!newWindow && showExpandCard" svgIcon="expand" (click)="openNewWindow()"></mat-icon>
      <mat-icon disableWksChange *ngIf="!newWindow" svgIcon="close" (click)="removeItemFromWorkspace()"
        matTooltipPosition="above" [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>

  <div class="container gridster-ignore-drag">

    <div class="row pl-1">
      <mat-tab-group class="col-12" (selectedTabChange)="changeTab($event)">
        <mat-tab label="Altas">
          <div class="col 12">
            <div class="row">
              <div class="no-data-msg" *ngIf="list?.length <= 0">{{ msgNoData }}</div>
              <div class="table-height" *ngIf="list?.length > 0">
                <div class="header-table">
                  <div class="line">
                    <div class="pos">POS.</div>
                    <div class="active">ATIVO</div>
                    <div class="price">PREÇO</div>
                    <div class="var">VAR. (%)</div>
                    <div class="size">VOLUME (R$)</div>
                  </div>
                </div>
                <div class="border-left high">
                  <table class="table-striped">
                    <tbody>
                      <tr *ngFor="let item of list">
                        <td class="pos">{{ item.pos }}</td>
                        <td class="active">{{ item.quote }}</td>
                        <td class="price">{{ item.priceFormat }}</td>
                        <td class="var" [ngClass]="{'high': item.valueColor > 0, 'low': item.valueColor < 0 }">
                          {{ item.valueColor > 0 ? '+' + item.value : item.valueColor === 0 ? 0 : item.value }}%
                        </td>
                        <td class="size">{{ item.volumeFinancier }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Baixas">
          <div class="col 12">
            <div class="row">
              <div class="table-height">
                <div class="no-data-msg" *ngIf="list?.length <= 0">{{ msgNoData }}</div>
                <div class="table-height" *ngIf="list?.length > 0">
                  <div class="header-table">
                    <div class="line">
                      <div class="pos">POS.</div>
                      <div class="active">ATIVO</div>
                      <div class="price">PREÇO</div>
                      <div class="var">VAR. (%)</div>
                      <div class="size">VOLUME (R$)</div>
                    </div>
                  </div>
                  <div class="border-left low">
                    <table class="table-striped">
                      <tbody>
                        <tr *ngFor="let item of list">
                          <td class="pos">{{ item.pos }}</td>
                          <td class="active">{{ item.quote }}</td>
                          <td class="price">{{ item.priceFormat }}</td>
                          <td class="var" [ngClass]="{'high': item.valueColor > 0, 'low': item.valueColor < 0}">
                            {{ item.valueColor > 0 ? '+' + item.value : item.valueColor === 0 ? 0 : item.value }}%
                          </td>
                          <td class="size">{{ item.volumeFinancier }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="+ Volume">
          <div class="col 12">
            <div class="row">
              <div class="table-height">
                <div class="no-data-msg" *ngIf="list?.length <= 0">{{ msgNoData }}</div>
                <div class="table-height" *ngIf="list?.length > 0">
                  <div class="header-table">
                    <div class="line">
                      <div class="pos">POS.</div>
                      <div class="active">ATIVO</div>
                      <div class="price">PREÇO</div>
                      <div class="var">VAR. (%)</div>
                      <div class="size">VOLUME (R$)</div>
                    </div>
                  </div>
                  <div class="border-left high">
                    <table class="table-striped">
                      <tbody>
                        <tr *ngFor="let item of list">
                          <td class="pos">{{ item.pos }}</td>
                          <td class="active">{{ item.quote }}</td>
                          <td class="price">{{ item.priceFormat }}</td>
                          <td class="var" [ngClass]="{'high': item.valueColor > 0, 'low': item.valueColor < 0}">
                            {{ item.valueColor > 0 ? '+' + item.value : item.valueColor === 0 ? 0 : item.value }}%
                          </td>
                          <td class="size">{{ item.volumeFinancier }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="- Volume">
          <div class="col 12">
            <div class="row">
              <div class="table-height">
                <div class="no-data-msg" *ngIf="list?.length <= 0">{{ msgNoData }}</div>
                <div class="table-height" *ngIf="list?.length > 0">
                  <div class="header-table">
                    <div class="line">
                      <div class="pos">POS.</div>
                      <div class="active">ATIVO</div>
                      <div class="price">PREÇO</div>
                      <div class="var">VAR. (%)</div>
                      <div class="size">VOLUME (R$)</div>
                    </div>
                  </div>
                  <div class="border-left low">
                    <table class="table-striped">
                      <tbody>
                        <tr *ngFor="let item of list">
                          <td class="pos">{{ item.pos }}</td>
                          <td class="active">{{ item.quote }}</td>
                          <td class="price">{{ item.priceFormat }}</td>
                          <td class="var" [ngClass]="{'high': item.valueColor > 0, 'low': item.valueColor < 0}">
                            {{ item.valueColor > 0 ? '+' + item.value : item.valueColor === 0 ? 0 : item.value }}%
                          </td>
                          <td class="size">{{ item.volumeFinancier }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
<div (window:beforeunload)="closeSheet()"></div>
